import XeroAdapter from './base';

export default class Ledger extends XeroAdapter {
  modelNamePlural = 'ledgers';
}
